import {
  useSelector as useReduxSelector,
  TypedUseSelectorHook,
} from "react-redux";
import { RootState } from "../slices";

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
